<template>
    <main
        id="auth"
        class="auth">
        <section class="content">
            <slot />
        </section>
        <img
            class="card-img"
            src="@/assets/images/Image11.webp" />
    </main>
</template>

<script>
    export default {
        name: "ProfileBase"
    };
</script>
<style scoped lang="scss">
    .content {
        width: 100%;
        padding: 2.5rem 1rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    img {
        margin-top: 2.5rem;
        height: 340px;
        width: 100%;
        object-fit: cover;
    }
</style>
